export const PRDescriptionPanelId = 'pull-request-description-panel';

export const getDraftLocalStorageKey = (
  containerId: string,
  currentUserId: string | undefined
): string => {
  return `${PRDescriptionPanelId}-${containerId}-${currentUserId}`;
};
